
import React, { useEffect, useRef, useState } from 'react';
import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import { SuccessfulMoadlPayment, SuccessfulModalPayment } from './SuccessfulModalPayment';
import { VerifyDiscountPayment } from './VerifyDiscountPaymentModel';
import { numberToWords } from '../../Utils/convertNumtoWord';
import Select from 'react-select';
import { getData, Postdata, Postdataform } from '../../API/GlobalApi';
import '../../assets/css/Modal.css';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import Notifier from '../../Utils/notify';
export const IndividualReceivePayment = ({ individualReceivePaymentModal, onClose, setIndividualReceivePaymentModal, selectedFeeDetails, modeOfPayment, setModeOfPayment, getStudentById
}) => {

    const [amount, setAmount] = useState();
    const [isPercentage, setIsPercentage] = useState(false);
    const [discountVerified, setDiscountVerified] = useState(false);
    const [discountValue, setDiscountValue] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const [discountObjectId, setDiscountObjectId] = useState(null)
    const [semesterName, setSemsterName] = useState('')
    const [paymentmodal, setpaymentmodal] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState(null)
    const [triggerGetStudentData, setTriggerGetStudentData] = useState(false);


    const academicGroups = Array.isArray(selectedFeeDetails?.academic_groups)
        ? selectedFeeDetails.academic_groups
        : [];

    const modeOfSemester = academicGroups.map(item => ({
        value: item.id,
        label: item.name,
    }));


    useEffect(() => {
        if (paymentmodal) {
            const timer = setTimeout(() => {
                setpaymentmodal(false);
                onClose();
            }, 3000);

            return () => clearTimeout(timer);
        } else if (!paymentmodal && triggerGetStudentData) {
            getStudentById(selectedFeeDetails?.id);
            setTriggerGetStudentData(false);
        }
    }, [paymentmodal]);



    const calculateTotal = () => {
        const amt = parseFloat(amount);
        const discountNum = parseFloat(discountValue);
        if (isNaN(amt) || amt <= 0) return 0;
        if (!discountVerified || isNaN(discountNum) || discountNum < 0) return amt;
        let discountAmount = isPercentage
            ? (amt * discountNum) / 100
            : discountNum;

        let total = amt - discountAmount;
        return total > 0 ? total : 0;
    };


    const totalPayment = calculateTotal();
    const [showDiscountModal, setShowDiscountModal] = useState(false)
    const openFeeDiscountModal = () => {
        setShowDiscountModal(true);
    };

    const closeFeeDiscountModal = () => {
        setShowDiscountModal(false);

    };
     

    const [feeType, setFeeType] = useState('');
    const [paymentTypes, setPaymentTypes] = useState([])

    const getFeeTypes = async () => {
        const url = 'students/get-payment-types/'
        const res = await getData(url)
        const options = res?.payment_types?.map((type) => ({
            label: type,
            value: type
        })) || [];

        setPaymentTypes(options);

    }

    useEffect(() => {
        getFeeTypes()
    }, []);




    const [chequeNumber, setChequeNumber] = useState('');
    const [bankName, setBankName] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [chequeImage, setChequeImage] = useState(null);
    const [chequeDate, setChecqueDate] = useState('');


    const [ddNumber, setDdNumber] = useState('');
    const [issueingBankBranchName, setIssueingBankBranchName] = useState('');
    const [ddissuingDate, seDdtIssuingDate] = useState('');
    const [ddpayeeName, setDdPayeeName] = useState('');
    const [payAbleAt, setPayAbleAt] = useState('')
    const [ddImage, setDDImage] = useState(null);

    const [utrNumber, setUtrNumber] = useState('');



    const feeDetails = [
        { feeHead: "Tuition Fee", semester: "Semester 1", scheduledAmount: 10000, amount: 5000 },
        { feeHead: "Library Fee", semester: "Semester 1", scheduledAmount: 2000, amount: 5000 },
        { feeHead: "Lab Fee", semester: "Semester 1", scheduledAmount: 3000, amount: 5000 }
    ];

    // Calculate totals
    const totalScheduled = feeDetails.reduce((sum, item) => sum + item.scheduledAmount, 0);
    const totalAmount = feeDetails.reduce((sum, item) => sum + item.amount, 0);

 


    const [errors, setErrors] = useState({});

    const validateField = (name, value) => {
        let message = "";

        switch (name) {
            case "accountNumber":
                if (!value.trim()) {
                    message = "Account number is required.";
                } else if (!/^[0-9]{9,18}$/.test(value)) {
                    message = "Account number must be 9 to 18 digits.";
                }
                break;

            case "ifscCode":
                if (!value.trim()) {
                    message = "IFSC code is required.";
                } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value.toUpperCase())) {
                    message = "Invalid IFSC format (e.g., SBIN0001234).";
                }
                break;

            case "holderName":
                if (!value.trim()) {
                    message = "Account holder name is required.";
                } else if (!/^[A-Za-z\s]{3,50}$/.test(value)) {
                    message = "Name must be alphabets only (3-50 chars).";
                }
                break;

            case "chequeNumber":
                if (!value.trim()) {
                    message = "Cheque number is required.";
                } else if (!/^[0-9]{6}$/.test(value)) {
                    message = "Cheque number must be 6 digits.";
                }
                break;

            case "ddNumber":
                if (!value.trim()) {
                    message = "Demand Draft number is required.";
                } else if (!/^[0-9]{6,9}$/.test(value)) {
                    message = "DD number must be 6–9 digits.";
                }
                break;

            case "utrNumber":
                if (!value.trim()) {
                    message = "UTR number is required.";
                } else if (!/^[A-Z0-9]{12,22}$/.test(value.toUpperCase())) {
                    message = "UTR must be 12–22 characters (alphanumeric).";
                }
                break;

            case "bankName":
                if (!value.trim()) {
                    message = "Bank name is required.";
                }
                break;
            case "ddNumber":
                if (!value) return "DD Number is required.";
                if (!/^[0-9]{6,9}$/.test(value)) return "DD Number must be 6–9 digits.";
                break;
            case "bankName":
                if (!value) return "Bank Name is required.";
                if (value.length < 3) return "Bank Name must be at least 3 characters.";
                if (!/^[A-Za-z\s]+$/.test(value)) return "Bank Name should contain only letters.";
                break;

            case "chequeImage":
            case "ddImage":
                if (!value) return "File is required.";
                const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypes.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) { // 2 MB
                    return "File size must be less than 2MB.";
                }
                break;
            case "issueingBankBranchName":
                if (!value.trim()) {
                    message = "Issuing Branch Name is required.";
                } else if (value.length < 3) {
                    message = "Branch Name must be at least 3 characters.";
                } else if (!/^[A-Za-z0-9\s,.-]+$/.test(value)) {
                    message = "Branch Name should contain only letters, numbers, spaces, commas, or dashes.";
                }
                break;

            case "payAbleAt":
                if (!value.trim()) {
                    message = "Payable At is required.";
                } else if (value.length < 3) {
                    message = "Payable At must be at least 3 characters.";
                } else if (!/^[A-Za-z\s]+$/.test(value)) {
                    message = "Payable At should contain only letters.";
                }
                break;

            case "chequeDate":
            case "ddissuingDate":
                if (!value) {
                    message = "Date is required.";
                }
                break;

            default:
                break;
        }

        return message;
    };
    const handleInputChange = (field, value) => {
        switch (field) {
            // Cheque fields
            case "chequeNumber":
                setChequeNumber(value.replace(/\D/g, "")); // only digits
                break;
            case "bankName":
                setBankName(value.replace(/[^a-zA-Z\s]/g, "")); // only alphabets
                break;
            case "ifscCode":
                setIfscCode(value.toUpperCase());
                break;
            case "chequeDate":
                setChecqueDate(value);
                break;
            case "chequeImage":
                setChequeImage(value); // file object
                break;

            // Demand Draft fields
            case "ddNumber":
                setDdNumber(value.replace(/\D/g, "")); // only digits
                break;
            case "issueingBankBranchName":
                setIssueingBankBranchName(value.replace(/[^a-zA-Z\s]/g, ""));
                break;
            case "ddissuingDate":
                seDdtIssuingDate(value);
                break;
            case "ddpayeeName":
                setDdPayeeName(value.replace(/[^a-zA-Z\s]/g, ""));
                break;
            case "payAbleAt":
                setPayAbleAt(value.replace(/[^a-zA-Z\s]/g, ""));
                break;
            case "ddImage":
                setDDImage(value); // file object
                break;

            // NEFT / RTGS
            case "utrNumber":
                setUtrNumber(value.toUpperCase());
                break;

            default:
                break;
        }

        // validate immediately
        const errorMsg = validateField(field, value);
        setErrors((prev) => ({ ...prev, [field]: errorMsg }));
    };

 

    const handleSubmitPayment = async () => {
        const today = new Date().toISOString().split('T')[0];
        const mode = selectedPaymentMode?.value;

             if (!mode) {
                Notifier.error("Please Select any mode of payment" );
            }
         
        // Validation
        if (mode === "Cheque") {
            if (!chequeNumber || !bankName || !ifscCode || !chequeImage || !chequeDate) {
                Notifier.error("Please fill all Cheque details" );
                return;
            }
        }

        if (mode === "Demand Draft") {
            if (!ddNumber || !ddissuingDate || !ddpayeeName || !payAbleAt || !issueingBankBranchName || !bankName || !ddImage) {
                  Notifier.error("Please fill all DD details" );
                return;
            }
        }

        if (mode === "NEFT" || mode === "RTGS") {
            if (!utrNumber) {
                  Notifier.error("Please enter UTR Number" );
                return;
            }
        }

   

        try {
            // Build FormData (snake_case keys)
            const formData = new FormData();
            formData.append("student_user_id", selectedFeeDetails?.id);
            formData.append("payment_date", today);
            formData.append("payment_method", mode);
            formData.append("amount", parseFloat(amount));
            formData.append("final_amount", parseFloat(totalPayment) || "");
            formData.append("discount_obj_id", discountObjectId || "");
            formData.append("fee_type", feeType || "");
            formData.append("academic_group_id", semesterName?.value || "");

            // Mode-specific fields
            if (mode === "Cheque") {
                formData.append("cheque_number", chequeNumber);
                formData.append("bank_name", bankName);
                formData.append("ifsc_code", ifscCode);
                formData.append("cheque_image", chequeImage); // File
                formData.append("cheque_date", chequeDate);
            }

            if (mode === "Demand Draft") {
                formData.append("dd_number", ddNumber);
                formData.append("issuing_bank", bankName);
                formData.append("date_of_issuing", ddissuingDate);
                formData.append("payee_name", ddpayeeName);
                formData.append("payable_at", payAbleAt);
                formData.append("issuing_branch", issueingBankBranchName);
                formData.append("dd_image", ddImage); // File
            }

            if (mode === "NEFT" || mode === "RTGS") {
                formData.append("utr_number", utrNumber);
            }

            // API call
            const url = 'finance/payments/receive/';
            const response = await Postdataform(url, formData);

            if (response && !response.error) {
                setPaymentResponse(response?.data);
                  Notifier.success(response?.message || 'Payment received successfully!');
                setpaymentmodal(true);
                setAmount('');
                setSemsterName('');
                setDiscountVerified(false);
              
                setSelectedPaymentMode('')
                setChecqueDate('')
                setSelectedEmployeeId(null);
                setEmployeeName('');
                setDiscountValue('');
                setIsPercentage(false);
                setTriggerGetStudentData(true);
            } else {
                  Notifier.error(response?.error || 'Payment failed. ');
                setpaymentmodal(false);
            }

        } catch (error) {
              Notifier.error(error?.response?.data?.message || 'An unexpected error occurred while processing payment.' );
            setpaymentmodal(false);
        }
    };


    const isDisabled = !selectedFeeDetails?.id || !amount || Number(amount) <= 0;


    const modeOfPaymentOptions = modeOfPayment?.map((mode) => ({
        value: mode,
        label: mode,
    }));


    const [showDebits, setShowDebits] = useState(false);
    const [showCredits, setShowCredits] = useState(false);

    const ledgerEntries = selectedFeeDetails?.ledger_data || [];

    const debitEntries = ledgerEntries.filter((e) => e.payment_type === "Debit");
    const creditEntries = ledgerEntries.filter((e) => e.payment_type === "Credit");

    if (!individualReceivePaymentModal) return null;

    return (<>
        <div className="modal-overlay">
            <div className="modal-content" style={{ position: 'relative', width: '70%', display: 'flex', flexDirection: 'column', overflowY: 'auto', height: '94vh' }}>
                <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h2 className='text-primary'>Receive Payment</h2>
                    <button className="close-btn" onClick={onClose}><img src={close} alt="close" /></button>
                </div>
                <div className="modal-body custom-modal-body" style={{ height: "auto", overflowY: 'scroll', padding: '0 10px', overflowX: 'hidden' }}>
                    <div className="row" style={{ background: '#F9FAFC', padding: "10px" }}>
                        <h4 className='fm-pr-hd'>STUDENT'S DETAILS</h4>
                        <div className="col-md-6">
                            <div className="student-details" style={{ textAlignLast: 'left' }}>
                                <div>
                                    <p className='sd-p'>Reg No</p>
                                    <p className='n-p-t'>{selectedFeeDetails?.permanent_registration_number}</p>
                                </div>
                                <div>
                                    <p className='sd-p'>Name</p>
                                    <p className='n-p-t'>{selectedFeeDetails?.name}</p>
                                </div>
                                <div>
                                    <p className='sd-p'>Phone</p>
                                    <p className='n-p-t'>{selectedFeeDetails?.contact_number} </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="student-details" style={{ textAlignLast: 'left' }}>
                                <div>
                                    <p className="sd-p">Profile type</p>
                                    <p className="n-p-t">{selectedFeeDetails?.profile_type}</p>
                                </div>
                                <div>
                                    <p className='sd-p'>Course</p>
                                    <p className='n-p-t'> {selectedFeeDetails?.course_name} </p>
                                </div>
                                <div>
                                        <p className="mt-3" style={{ color: '#7f56da', fontWeight: 'bold' }}>Balance</p>
                                        <p className=""  >{selectedFeeDetails?.financial_summary?.outstanding_balance}</p>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 d-flex justify-content-center m-auto">
                        <div className="col-md-10">
                            <div className="payment-form" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label className='form-labell'>Mode of Payment<span className="astrisk">*</span>
                                            {/* <span className='astrisk'>*</span> */}
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select
                                            id="paymentMode"
                                            className="basic-single"
                                            classNamePrefix="select"
                                            options={modeOfPaymentOptions}
                                            value={selectedPaymentMode}
                                            onChange={setSelectedPaymentMode}
                                            menuPlacement="auto"
                                            menuPosition="absolute"
                                            isSearchable
                                            placeholder="Select Payment Mode"
                                            styles={{
                                                ...reactSelectStyles,
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 999999999,
                                                }),
                                                menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999999999,
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                                {selectedPaymentMode?.value === "Cheque" && (
                                    <>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Cheque Number<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={chequeNumber}
                                                    placeholder="Enter cheque number"
                                                    onChange={(e) => handleInputChange("chequeNumber", e.target.value)}
                                                />
                                                {errors.chequeNumber && <p className="text-danger">{errors.chequeNumber}</p>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Bank Name<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={bankName}
                                                    onChange={(e) => {
                                                        // Allow only alphabets & spaces
                                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                        handleInputChange("bankName", onlyLetters);
                                                    }}
                                                    placeholder="Enter bank name"
                                                />
                                                {errors.bankName && <p className="text-danger">{errors.bankName}</p>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    IFSC Code<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={ifscCode}
                                                    onChange={(e) => handleInputChange("ifscCode", e.target.value)}
                                                    placeholder="Enter IFSC code"
                                                />
                                                {errors.ifscCode && <p className="text-danger">{errors.ifscCode}</p>}
                                            </div>
                                        </div>



                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Upload Cheque Image
                                                    <span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="form-control fm-modal"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        handleInputChange("chequeImage", file);
                                                    }}
                                                />
                                                {errors.chequeImage && <p className="text-danger">{errors.chequeImage}</p>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Cheque Date<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="date"
                                                    className="form-control fm-modal"
                                                    value={chequeDate}
                                                    onChange={(e) => setChecqueDate(e.target.value)}
                                                    placeholder="Enter IFSC code"
                                                      min={new Date().toISOString().split("T")[0]} 
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                {selectedPaymentMode?.value === "Demand Draft" && (
                                    <>
                                        {/* DD Number */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Demand Draft Number<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={ddNumber}
                                                    onChange={(e) => {
                                                        const onlyDigits = e.target.value.replace(/\D/g, "");
                                                        handleInputChange("ddNumber", onlyDigits);
                                                    }}
                                                    placeholder="Enter DD number"
                                                />
                                                {errors.ddNumber && <p className="text-danger">{errors.ddNumber}</p>}
                                            </div>
                                        </div>

                                        {/* Bank Name */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Bank Name<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={bankName}
                                                    onChange={(e) => {
                                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                        handleInputChange("bankName", onlyLetters);
                                                    }}
                                                    placeholder="Enter bank name"
                                                />
                                                {errors.bankName && <p className="text-danger">{errors.bankName}</p>}
                                            </div>
                                        </div>

                                        {/* Issuing Branch Name */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Issuing Branch Name<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={issueingBankBranchName}
                                                    onChange={(e) => {
                                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                        handleInputChange("issueingBankBranchName", onlyLetters);
                                                    }}
                                                    placeholder="Enter issuing bank & branch"
                                                />
                                                {errors.issueingBankBranchName && (
                                                    <p className="text-danger">{errors.issueingBankBranchName}</p>
                                                )}
                                            </div>
                                        </div>

                                        {/* Date of Issuing */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Date of Issuing<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="date"
                                                    className="form-control fm-modal"
                                                    value={ddissuingDate}
                                                    onChange={(e) => handleInputChange("ddissuingDate", e.target.value)}
                                                     min={new Date().toISOString().split("T")[0]} 
 
                                                />
                                                {errors.ddissuingDate && (
                                                    <p className="text-danger">{errors.ddissuingDate}</p>
                                                )}
                                            </div>
                                        </div>

                                        {/* Payee Name */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Payee Name<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={ddpayeeName}
                                                    onChange={(e) => {
                                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                        handleInputChange("ddpayeeName", onlyLetters);
                                                    }}
                                                    placeholder="Enter payee name"
                                                />
                                                {errors.ddpayeeName && (
                                                    <p className="text-danger">{errors.ddpayeeName}</p>
                                                )}
                                            </div>
                                        </div>

                                        {/* Payable At */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Payable At<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={payAbleAt}
                                                    onChange={(e) => {
                                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                        handleInputChange("payAbleAt", onlyLetters);
                                                    }}
                                                    placeholder="Enter city/location"
                                                />
                                                {errors.payAbleAt && <p className="text-danger">{errors.payAbleAt}</p>}
                                            </div>
                                        </div>

                                        {/* Upload DD Image */}
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    Upload DD Image<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="file"
                                                    accept="image/*,.pdf"
                                                    className="form-control fm-modal"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        handleInputChange("ddImage", file);
                                                    }}
                                                />
                                                {errors.ddImage && <p className="text-danger">{errors.ddImage}</p>}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {(selectedPaymentMode?.value === "NEFT" ||
                                    selectedPaymentMode?.value === "RTGS") && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-labell">
                                                    UTR Number<span className="astrisk">*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control fm-modal"
                                                    value={utrNumber}
                                                    onChange={(e) => handleInputChange("utrNumber", e.target.value)}
                                                    placeholder="Enter UTR number"
                                                />
                                                {errors.utrNumber && <p className="text-danger">{errors.utrNumber}</p>}
                                            </div>
                                        </div>
                                    )}
                                <div className="row">
                                    <div className="col-md-4">
                                        <label className='form-labell'>Amount<span className='astrisk'>*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                        <input type="text"
                                            min="0"
                                            className="form-control fm-modal"
                                            value={amount}
                                            onChange={(e) => {
                                                const cleaned = e.target.value.replace(/[^0-9]/g, '');
                                                setAmount(cleaned);
                                            }}
                                            placeholder="Enter amount"

                                        />
                                    </div>
                                </div>
                                {/*<div className="row">
                                    {discountVerified && (
                                        <>
                                            <div className="col-md-4">
                                                <label className="form-labell">Any Discount</label>
                                            </div>
                                            <div className="col-md-4" style={{ display: 'flex', alignItems: 'center' }}>
                                            
                                                <input
                                                    type="text"
                                                    min="0"
                                                    className="form-control fm-modal"
                                                    value={discountValue}

                                                    onChange={(e) => {
                                                        const cleaned = e.target.value.replace(/[^0-9]/g, '');
                                                        setDiscountValue(cleaned);
                                                    }}
                                                    style={{ width: '40%' }}
                                                    placeholder={isPercentage ? 'Enter %' : 'Enter amount'}
                                                    disabled={discountVerified}
                                                />
                                                <div style={{ display: 'flex', gap: '10px', marginLeft: '10px', }}>
                                                    <label className='d-flex align-items-center'>

                                                        <input
                                                            type="radio"
                                                            checked={isPercentage}
                                                            onChange={() => setIsPercentage(true)}
                                                            disabled={discountVerified}
                                                        />{' '}
                                                        %
                                                    </label>
                                                    <label className='d-flex align-items-center'>
                                                        <input
                                                            type="radio"
                                                            checked={!isPercentage}
                                                            onChange={() => setIsPercentage(false)}
                                                            disabled={discountVerified}
                                                        />{' '}
                                                        Value
                                                    </label>


                                                </div>
 
                                            </div>
                                        </>
                                    )}
                                    <div
                                        className={
                                            discountVerified
                                                ? 'col-md-4 d-flex justify-content-end align-items-center'
                                                : 'col-md-12 d-flex justify-content-end align-items-center'}>

                                        <button
                                            type="button"
                                            aria-disabled={isDisabled}
                                            onClick={(e) => {
                                                if (isDisabled) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                openFeeDiscountModal();
                                            }}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                cursor: selectedFeeDetails?.id && amount ? 'pointer' : 'not-allowed',
                                                backgroundColor: selectedFeeDetails?.id && amount ? '#7F56DA' : '#d3d3d3',
                                            }}
                                        >
                                            {discountVerified ? 'Edit Discount' : 'Apply Discount'}
                                        </button>
                                    </div>
                                </div> */}

                                {/* <div className="row">
                                    <div className="col-md-4">
                                        <label className='form-labell'>Total Payment<span className='astrisk'>*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                        <input type="text" className='form-control fm-modal' value={totalPayment.toFixed(2)} disabled />
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="col-md-4">
                                        <label className='form-labell'>Amount in words</label>
                                    </div>
                                    <div className="col-md-8 mt-3">
                                        <p><strong style={{ color: "#7F56DA", fontWeight: "bold" }} >{numberToWords(calculateTotal()).toUpperCase()} ONLY</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3">
                        {/* Credit Ledger Entries */}
                        <div className="mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center p-2 bg-light border rounded"
                                onClick={() => setShowCredits(!showCredits)}
                                style={{ cursor: "pointer" }}
                            > 
                                <h6 className="mb-0">Fee Received ({selectedFeeDetails?.financial_summary?.total_credits})</h6>
                                <span>{showCredits ? "▲" : "▼"}</span>
                            </div>
                            {showCredits && (
                                <div className="mt-2 paymentreporttablecontainer" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-bordered feeledgerlist">
                                        <thead style={{ background: "#F0F0F0", position: "sticky", top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th>Payment Date</th>
                                                {/* <th>Unique ID</th> */}
                                                {/* <th>Fee Head</th> */}
                                                <th>Amount</th>
                                                 <th>Received By</th>
                                                <th>Payment Mode</th>
                                                
                                                <th>Details</th>

                                                {/* <th>Remarks</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {creditEntries.length > 0 ? (
                                                creditEntries.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            {item.payment_date  }
                                                        </td>
                                                        {/* <td>{item.unique_id}</td> */}
                                                        {/* <td>{item.fee_head || "-"}</td> */}
                                                        <td>₹ {item.amount.toLocaleString()}</td>
                                                         <td>{item.created_by}</td>
                                                        <td>{item.mode_of_payment}</td>
                                                        
                                                        <td>
                                                            {item.transaction ? (
                                                                item.transaction.cheque_number ? (
                                                                    <span><strong>Cheque No:</strong> {item.transaction.cheque_number}</span>
                                                                ) : item.transaction.dd_number ? (
                                                                    <span><strong>DD No:</strong> {item.transaction.dd_number}</span>
                                                                ) : item.transaction.utr_number ? (
                                                                    <span><strong>UTR No:</strong> {item.transaction.utr_number}</span>
                                                                ) : (
                                                                    "-"
                                                                )
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>


                                                        {/* <td>{item.remarks || "-"}</td> */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No Credit Entries Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        {/* Debit Ledger Entries */}
                        <div className="mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center p-2 bg-light border rounded"
                                onClick={() => setShowDebits(!showDebits)}
                                style={{ cursor: "pointer" }}
                            >
                                <h6 className="mb-0">Fee Due ({selectedFeeDetails?.financial_summary?.total_debits})</h6>
                                <span>{showDebits ? "▲" : "▼"}</span>
                            </div>
                            {showDebits && (
                                <div className="mt-2 paymentreporttablecontainer" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-bordered feeledgerlist">
                                        <thead style={{ background: "#F0F0F0", position: "sticky", top: 0, zIndex: 1 }}>
                                            <tr>  <th>Due Date</th>
                                                {/* <th>Unique ID</th> */}
                                                <th>Fee Head</th>
                                                <th>Amount</th>
                                               
                                                <th>Details</th>

                                                {/* <th>Remarks</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {debitEntries.length > 0 ? (
                                                debitEntries.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            {item.due_date}
                                                        </td>
                                                         <td>{item.fee_head || "-"}</td>
                                                          <td>₹ {item.amount.toLocaleString()}</td>
                                                        {/* <td>{item.unique_id}</td> */}
                                                        
                                                       
                                                        {/* <td>{item.mode_of_payment}</td> */}
                                                        <td>
                                                            {item.transaction ? (
                                                                item.transaction.cheque_number ? (
                                                                    <span><strong>Cheque No:</strong> {item.transaction.cheque_number}</span>
                                                                ) : item.transaction.dd_number ? (
                                                                    <span><strong>DD No:</strong> {item.transaction.dd_number}</span>
                                                                ) : item.transaction.utr_number ? (
                                                                    <span><strong>UTR No:</strong> {item.transaction.utr_number}</span>
                                                                ) : (
                                                                    "-"
                                                                )
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>

                                                        {/* <td>{item.remarks || "-"}</td> */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No Debit Entries Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>


                    </div>
                </div>
                <div className="form-actions mt-5 " style={{ position: 'sticky', background: 'white', display: 'flex', justifyContent: '', alignItems: 'center' }}>
                    <div>
                        <button type="submit"
                            disabled={!amount}
                            style={{
                                display: 'flex', alignItems: 'center', gap: "10px",
                                cursor: amount ? 'pointer' : 'not-allowed',
                                backgroundColor: amount ? '#7F56DA' : '#d3d3d3',
                            }} onClick={handleSubmitPayment} >Receive Payment<img src={next}></img></button>
                    </div>
                </div>
            </div>
            {/* <VerifyDiscountPayment isOpen={showDiscountModal} onClose={closeFeeDiscountModal} onVerify={() => {
                setDiscountVerified(true);
                closeFeeDiscountModal();
            }}
                discountValue={discountValue}
                setDiscountValue={setDiscountValue}
                isPercentage={isPercentage}
                setIsPercentage={setIsPercentage}
                employeeName={employeeName}
                setEmployeeName={setEmployeeName}
                selectedEmployeeId={selectedEmployeeId}
                setSelectedEmployeeId={setSelectedEmployeeId}
                studentId={selectedFeeDetails?.id}
                totalAmount={calculateTotal()}
                discountObjectId={discountObjectId}
                setDiscountObjectId={setDiscountObjectId}
              
            /> */}
        </div>


         
        {paymentmodal && paymentResponse && (
            <SuccessfulModalPayment
                mainheading="Payment Success!"
                onClose={onClose}
                paymentResponse={paymentResponse}
                submitclose={() => setpaymentmodal(false)}

            />
        )}
    </>

    );

};
